@if (label(); as texto) {
  <label class="campo__label" [for]="idUnico">{{ texto }}</label>
}

<div class="campo__caja" [class.campo__caja--multilinea]="multilinea()">
  @if (multilinea()) {
    <textarea
      class="campo__control"
      [id]="idUnico"
      [placeholder]="placeholder()"
      [value]="valor()"
      [attr.maxlength]="maxLargo()"
      [disabled]="estado() === 'deshabilitado'"
      (input)="onInput($event)"
      (blur)="tocar()"
    ></textarea>
  } @else {
    <input
      class="campo__control"
      type="text"
      [id]="idUnico"
      [placeholder]="placeholder()"
      [value]="valor()"
      [attr.maxlength]="maxLargo()"
      [disabled]="estado() === 'deshabilitado'"
      (input)="onInput($event)"
      (blur)="tocar()"
    />
  }
</div>

@if (textoAyuda(); as ayuda) {
  <p class="campo__ayuda">{{ ayuda }}</p>
}
